// extracted by mini-css-extract-plugin
export default {"root":"_290UH","icon":"_1Vr0u","active-icon":"_3ITr_","activeIcon":"_3ITr_"};